module.exports = __webpack_public_path__ + "img/collection-weddingRingsSecretHeart.e9f5d0c.jpg";